import { Loader2, Eye, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/LanguageContext";
import { calculatePrice, MAX_SLIDER_DOMAINS } from "@/lib/pricing";

const CheckoutButtons = ({ selectedTier, isProcessing, onCheckout, domainCount = 100 }) => {
  const { t } = useLanguage();

  const adPrice = calculatePrice("ad", domainCount);
  const fullPrice = calculatePrice("full", domainCount);
  const overLimit = domainCount > MAX_SLIDER_DOMAINS;

  return (
    <div className="mt-10 space-y-4">
      {(selectedTier === null || selectedTier === "ad") && (
        <Button
          onClick={() => onCheckout("ad")}
          disabled={isProcessing || overLimit}
          className={`w-full py-6 text-base font-bold uppercase tracking-wide rounded-xl ${
            selectedTier === "ad"
              ? "btn-accent"
              : "bg-white/10 hover:bg-white/20 text-white"
          }`}
          data-testid="checkout-ad-btn"
        >
          {isProcessing ? (
            <>
              <Loader2 className="w-5 h-5 mr-2 animate-spin" />
              {t("checkout.redirecting")}
            </>
          ) : overLimit ? (
            t("checkout.contactSales")
          ) : (
            <>
              <Eye className="w-5 h-5 mr-2" />
              {t("checkout.adButton", { price: adPrice })}
            </>
          )}
        </Button>
      )}

      {(selectedTier === null || selectedTier === "full") && (
        <Button
          onClick={() => onCheckout("full")}
          disabled={isProcessing || overLimit}
          className={`w-full py-6 text-base font-bold uppercase tracking-wide rounded-xl ${
            selectedTier === "full" || selectedTier === null
              ? "btn-accent"
              : "bg-white/10 hover:bg-white/20 text-white"
          }`}
          data-testid="checkout-full-btn"
        >
          {isProcessing ? (
            <>
              <Loader2 className="w-5 h-5 mr-2 animate-spin" />
              {t("checkout.redirecting")}
            </>
          ) : overLimit ? (
            t("checkout.contactSales")
          ) : (
            <>
              <Mail className="w-5 h-5 mr-2" />
              {t("checkout.fullButton", { price: fullPrice })}
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default CheckoutButtons;
